import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";

/*
 * Copyright (C) 2022 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import * as SvgProcessor from './SvgCategoryProcessor';
export async function process(file) {
  var _file$type;

  // Determine which processor to use based on file type.
  // If no matching processor is found for the given file type, return undefined
  if (file !== null && file !== void 0 && (_file$type = file.type) !== null && _file$type !== void 0 && _includesInstanceProperty(_file$type).call(_file$type, SvgProcessor.typeTest)) {
    return await SvgProcessor.process(file);
  }
}